export default __webpack_public_path__ + "static/sustainability_water_ink-d52019bf53feed70dfbd5095444fbee0.svg";